export const environment = {
  apiUrl: "https://quissama.pontobiometrico.com.br/api/app",
  production: false
};
